module.exports = __webpack_public_path__ + "static/media/shs.ded5ee12.png";